type Preschool = {
  PreschoolCDSCode: string;
  PreschoolName: string;
};

type ClassroomForHeading = {
  ClassroomName?: string | null;
  LocalClassroomId?: string | null;
  PreschoolCode?: string | null;
  ProgramYear?: string | null;
};

export function classroomHeadingModel({
  classroom,
  leaid,
  preschools,
}: {
  classroom: ClassroomForHeading;
  leaid: string;
  preschools: Preschool[];
}) {
  const classroomName = classroom.ClassroomName?.trim() || "Unknown Classroom";

  // Get initials from classroom name or use classroom icon
  const nameParts = classroomName.split(/\s+/);
  let initials = "";

  if (nameParts.length >= 2) {
    initials = `${nameParts[0][0]}${nameParts[1][0]}`;
  } else if (nameParts.length === 1 && nameParts[0].length >= 2) {
    initials = nameParts[0].substring(0, 2);
  } else {
    initials = classroom.LocalClassroomId?.[0] || "C";
  }

  const school =
    preschools.find((x) => x.PreschoolCDSCode === classroom.PreschoolCode)
      ?.PreschoolName ?? "Unknown preschool";

  return {
    classroomName,
    initials,
    leaid,
    school,
    localClassroomId: classroom.LocalClassroomId ?? "",
    programYear: classroom.ProgramYear ?? "",
  };
}
